import ChariotWrapper from 'components/ChariotWrapper';
import { Link } from 'components/Link';
import { Row } from 'components/Row';
import { BodySmall } from 'components/Typography';
import theme from 'config/theme';
import { FC, useEffect, useState } from 'react';
import { ProcessingRow, SubmitButton } from 'screens/Checkout/styled';
import { useParams } from 'react-router-dom';
interface Props {
  onDonationRequest: () => object;
  chariotConnectId?: string | false | undefined;
  onChariotDonateSuccess: (response: any) => void;
  valid: boolean;
  submitting: boolean;
  submitError?: string | null;
  isSubmitReady: boolean;
  submit: () => void;
}

// hack to fix need to click twice to submit
// when clicking from focused field to DAF Pay button
const onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
  e.preventDefault();
};

export const SubmitButtonContainer: FC<Props> = ({
  chariotConnectId,
  onDonationRequest,
  onChariotDonateSuccess,
  submitting,
  submitError,
  valid,
  isSubmitReady,
  submit,
}) => {
  const { urlPartner } = useParams();
  const [isChariotClosedEarly, setIsChariotClosedEarly] = useState(false);

  useEffect(() => {
    if (isSubmitReady) {
      setIsChariotClosedEarly(false);
      submit();
    }
  }, [isSubmitReady]);

  const onChariotExit = () => {
    setIsChariotClosedEarly(true);
  };

  return (
    <>
      {chariotConnectId && (
        <Row
          className={submitting ? 'display-none' : ''}
          $justifyContent="space-around"
          onMouseDown={onMouseDown}
        >
          <ChariotWrapper
            onDonationRequest={onDonationRequest}
            chariotConnectId={chariotConnectId}
            onSuccess={onChariotDonateSuccess}
            onExit={onChariotExit}
            disabled={!valid && !submitError}
            hasError={!!submitError}
          />
        </Row>
      )}
      {submitting && (
        <>
          <SubmitButton
            className="animated-background"
            type="button"
            disabled={true}
            $submitting={true}
            $secondary={false}
            $hasBorder={false}
          >
            Processing
          </SubmitButton>
          <ProcessingRow>
            <BodySmall>
              Your pledge is processing.
              <br />
              Please do not refresh your browser.
            </BodySmall>
          </ProcessingRow>
        </>
      )}
      {submitError && !submitting && (
        <ProcessingRow>
          <BodySmall $color={theme.colors.errorRed}>{submitError}</BodySmall>
        </ProcessingRow>
      )}
      {isChariotClosedEarly && (
        <ProcessingRow>
          <BodySmall $color={theme.colors.errorRed}>
            The DAF form was closed before the payment was processed.{' '}
            <Link to={`/donate?p=${urlPartner}`}>Click here</Link> if you would like to return to
            the donate page and use another payment method.
          </BodySmall>
        </ProcessingRow>
      )}
    </>
  );
};
